import { render, staticRenderFns } from "./mode-rule.vue?vue&type=template&id=5b2360f0&scoped=true"
import script from "./mode-rule.vue?vue&type=script&lang=js"
export * from "./mode-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2360f0",
  null
  
)

export default component.exports